import { Icon } from '@chakra-ui/react'
import { BrandColorsRaw } from 'commons/design-system/tokens'
import { TbShare2 } from 'react-icons/tb'

export const ShareIcon = () => <Icon as={TbShare2} boxSize='22px' color={BrandColorsRaw.PRIMARY} />
